(
    function (skyward, $)
    {
        skyward.promptsview = skyward.promptsview || {};

        var initParametersPrompt = function (selector)
        {
            const selectorElement = $(selector);

            selectorElement.find(".reportRuntimeUserInstructions, .processRuntimePromptInstructions").each(function ()
            {
                const jqThis = $(this);
                const label = jqThis.prev();
                jqThis.css("margin-left", parseInt(label.css("margin-left")) + label.outerWidth() + "px");
            });

            const inputs = selectorElement.find(".filterValue");

            if (!inputs.length)
            {
                return;
            }

            const allReliantPrompts = [];
            // hasDependentPrompts means "has dependencies". A "dependentPrompt" is a prompt with dependents (aka a prompt with reliant prompts), not a prompt that is a dependent
            inputs.filter(".hasDependentPrompts").each(function ()
            {
                const reliantPrompt =
                {
                    input: $(this),
                    dependencies: []
                };
                reliantPrompt.container = reliantPrompt.input.parent();
                reliantPrompt.disabledMessage = reliantPrompt.container.find(".dmseDisabledMessage");

                reliantPrompt.data = reliantPrompt.input.hasClass("dmsBackingData") ? reliantPrompt.container.data() : reliantPrompt.input.data();

                allReliantPrompts.push(reliantPrompt);
            });

            if (allReliantPrompts.length > 0)
            {
                inputs.each(function ()
                {
                    const prompt =
                    {
                        input: $(this),
                        reliantPrompts: []
                    };
                    if (prompt.input.hasClass("dmsBackingData"))
                    {
                        prompt.data = prompt.input.parent().data();
                    }
                    else if (prompt.input.hasClass("multiSelectBackingData"))
                    {
                        prompt.data = prompt.input.parent(".multipleSelectBox").data();
                    }
                    else
                    {
                        prompt.data = prompt.input.data();
                    }

                    $.each(allReliantPrompts, function (index, reliantPrompt)
                    {
                        const dependencyUniqueIds = reliantPrompt.input.data("dependentPromptUniqueIds"); // DependentPromptUniqueIds are the prompts *on which this prompt depends*, not prompts that *are dependents* of another prompt
                        if (dependencyUniqueIds && dependencyUniqueIds.length > 0 && dependencyUniqueIds.indexOf(prompt.data.promptUniqueId) >= 0)
                        {
                            prompt.reliantPrompts.push(reliantPrompt);
                            reliantPrompt.dependencies.push(prompt); // Catalog all dependencies so we know when it's OK to enable an input
                        }
                    });

                    prompt.friendlyName = prompt.data.promptName;

                    let promptInputs = prompt.input.closest(".fieldWrapper").find(".filterValue");
                    if (promptInputs.length > 1)
                    {
                        let lowLabel = promptInputs.first().data().promptName;
                        prompt.friendlyName = lowLabel + ((lowLabel === prompt.friendlyName) ? " Low" : " High");
                    }

                    if (prompt.reliantPrompts.length > 0)
                    {
                        const updateReliantPrompts = function (clear)
                        {
                            for (let reliantPrompt of prompt.reliantPrompts)
                            {
                                if (clear)
                                {
                                    reliantPrompt.input.trigger("clearAll");
                                }

                                let foundInvalidDependency = false;
                                for (let dependency of reliantPrompt.dependencies)
                                {
                                    let promptValue = skyward.controls.getValue(dependency.input);
                                    if (isPromptValueBlank(promptValue))
                                    {
                                        if (dependency.data.presenceType === "Required" && dependency.input.closest(".promptFieldSet").is(":visible"))
                                        {
                                            foundInvalidDependency = true;
                                            reliantPrompt.container.children().hide();
                                            reliantPrompt.disabledMessage.text("Enter a value for " + dependency.friendlyName).show();
                                            break;
                                        }
                                    }
                                    else if (dependency.data.promptType === "Value" && dependency.data.promptMax !== undefined && dependency.data.promptMin !== undefined)
                                    {
                                        if (dependency.data.fieldType === "Number Long")
                                        {
                                            continue;
                                        }
                                        /* This won't work correctly if dependency.data.fieldType is Number Long, since we don't support using BigInt yet due to old versions of Safari on older iOS devices.
                                         * To get around this limitation we are masking the prompt to at most 18 characters instead of 19, which guaranties the input is a valid long and we can skip this validation.
                                         * See PR 5271305
                                         */

                                        let max = dependency.data.promptMax;
                                        let min = dependency.data.promptMin;

                                        if (promptValue < min || promptValue > max)
                                        {
                                            foundInvalidDependency = true;
                                            reliantPrompt.container.children().hide();
                                            reliantPrompt.disabledMessage.text(dependency.friendlyName + " must be between " + min + " and " + max).show();
                                            break;
                                        }
                                    }
                                }

                                if (!foundInvalidDependency)
                                {
                                    reliantPrompt.container.children().not(".distinctMultiSelectClearButton").show();
                                    reliantPrompt.disabledMessage.hide();
                                }
                            }
                        };

                        let lastEnteredValue = JSON.stringify(skyward.controls.getValue(prompt.input));
                        // For relative & old date pickers 'change' can fire before the value really changes. After the change,
                        // 'dirty' fires for relative dates and 'datePickerChangeComplete' fires for normal dates
                        const changeEvents = prompt.input.hasClass("datepicker") ? "datePickerChangeComplete dirty" : "change";
                        prompt.input.on(changeEvents + " keyup togglePrompt", function ()
                        {
                            const newVal = JSON.stringify(skyward.controls.getValue(prompt.input));

                            updateReliantPrompts(newVal !== lastEnteredValue);
                            lastEnteredValue = JSON.stringify(skyward.controls.getValue(prompt.input));

                        });

                        updateReliantPrompts(false);
                    }
                });
            }

            function isPromptValueBlank(val)
            {
                if ($.isEmptyObject(val))
                {
                    return true;
                }

                if (val)
                {
                    if (val instanceof Date)
                    {
                        return isNaN(val);
                    }

                    return val.toString().trim().length === 0;
                }
                return true;
            }

            const conditionalPromptInfo = new Map();
            const fieldSetByPromptUniqueID = new Map();

            //Loop over the prompt field sets to setup the collections of info we will need later
            const promptContainers = selectorElement.find(".js-promptContainer");

            promptContainers.each(function ()
            {
                const fieldSet = $(this);
                const hiddenCondition = fieldSet.data("hiddenCondition");
                const promptUniqueID = fieldSet.data("promptUniqueId");

                fieldSetByPromptUniqueID.set(promptUniqueID, fieldSet);


                if (hiddenCondition)
                {
                    const watchingPromptUniqueID = hiddenCondition.LeftOperand.PromptUniqueID;

                    if (watchingPromptUniqueID)
                    {
                        if (!conditionalPromptInfo.has(watchingPromptUniqueID))
                        {
                            conditionalPromptInfo.set(watchingPromptUniqueID, []);
                        }
                        conditionalPromptInfo.get(watchingPromptUniqueID).push({
                            promptUniqueID: promptUniqueID,
                            hiddenCondition: hiddenCondition,
                            fieldSet: fieldSet
                        });
                    }
                }
            });

            /**
             * Gets the Prompt inputs ordered starting with the ones that don't have a hidden condition then the ones that look them and so on
             */
            function GetPromptInputsInDependentOrder()
            {
                let fieldsetsInOrder = [];
                const promptUniqueIDsAlreadyOrdered = [];
                let fieldsetsLeftToOrder = [];

                //Get the prompts with no hidden conditions first
                promptContainers.each(function ()
                {
                    const fieldset = $(this);
                    const promptUniqueID = fieldset.data("promptUniqueId");

                    if (conditionalPromptInfo.has(promptUniqueID))
                    {
                        fieldsetsLeftToOrder.push(fieldset);
                    }
                    else
                    {
                        promptUniqueIDsAlreadyOrdered.push(promptUniqueID);
                        fieldsetsInOrder.push(fieldset);
                    }
                });

                let countLastLoop = -1;
                //Keep looping over the prompts left checking to see if the prompt they need has already been processed
                while (fieldsetsLeftToOrder.length > 0)
                {
                    //if we didn't remove any prompts from the ones left then we are in a circular reference so just get out and show all the prompts
                    if (fieldsetsLeftToOrder.length === countLastLoop)
                    {
                        fieldsetsLeftToOrder = [];
                        fieldsetsInOrder = [];
                    }

                    countLastLoop = fieldsetsLeftToOrder.length;
                    const fieldsetsToProcess = [...fieldsetsLeftToOrder];
                    fieldsetsLeftToOrder = [];

                    $(fieldsetsToProcess).each(function ()
                    {
                        const fieldset = $(this);
                        const promptUniqueID = fieldset.data("promptUniqueId");

                        let allDependentsAccountedFor = true;
                        $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                        {
                            const promptInfo = this;
                            if (!promptUniqueIDsAlreadyOrdered.includes(promptInfo.promptUniqueID))
                            {
                                allDependentsAccountedFor = false;
                            }
                        });

                        if (allDependentsAccountedFor)
                        {
                            promptUniqueIDsAlreadyOrdered.push(promptUniqueID);
                            fieldsetsInOrder.push(fieldset);
                        }
                        else
                        {
                            fieldsetsLeftToOrder.push(fieldset);
                        }
                    });

                }

                let promptsInOrder = [];

                $(fieldsetsInOrder).each(function ()
                {
                    const fieldset = $(this);

                    if (!fieldset.hasClass("standardFilterViewer"))
                    {
                        fieldset.find(".filterValue").each(function ()
                        {
                            promptsInOrder.push($(this));
                        });
                    }
                });

                return promptsInOrder;
            }

            //Loop over all the inputs to set the fields to hidden or shown based on their current values
            const promises = [];
            const inputsInOrder = GetPromptInputsInDependentOrder();
            for (let i = 0; i < inputsInOrder.length; i++)
            {
                const input = inputsInOrder[i];
                const promise = getHiddenConditionEvaluationPromise(input, i);
                if (promise != null)
                {
                    promises.push(promise);
                }
            }
            if (promises.length > 0)
            {
                handleHiddenConditionEvaluationPromises(promises, false);
            }

            for (let input of inputs)
            {
                let $input = $(input);
                // For relative & old date pickers 'change' can fire before the value really changes. After the change,
                // 'dirty' fires for relative dates and 'datePickerChangeComplete' fires for normal dates
                const changeEvents = $input.hasClass("datepicker") ? "datePickerChangeComplete dirty" : "change";

                $input.on(changeEvents, function ()
                {
                    if ($input.closest(".promptFieldSet").is(":visible"))
                    {
                        evaluateHiddenConditions($input);
                    }
                    else
                    {
                        hidePromptsThatWatchThisPrompt($input.data("promptUniqueId"));
                    }
                });
            }

            /**
             * Asks the server to evaluate any hidden conditions that are looking to this prompt input for changes and applies those changes
             * @param {any} input The jQuery Prompt Input that changed
             */
            function evaluateHiddenConditions(input)
            {
                const promise = getHiddenConditionEvaluationPromise(input);
                if (promise != null)
                {
                    handleHiddenConditionEvaluationPromises([promise], true);
                }
            }

            /**
             * Asks the server to evaluate any hidden conditions that are looking to this prompt input for changes
             * @param {any} input The jQuery Prompt Input that changed
             * @param {number} order If multiple changes are being processed the order they should be processed in
             * @returns {Promise} A Promise object for the AJAX request to evaluate the Hidden Condition or null if the input has no prompts looking to it for changes
             */
            function getHiddenConditionEvaluationPromise(input, order = 0)
            {
                const inputData = input.data();
                const promptUniqueID = inputData.promptUniqueId;
                const dataType = inputData.fieldType;

                if (conditionalPromptInfo.has(promptUniqueID))
                {
                    const hiddenConditionInfos = {};
                    let inputValue = skyward.controls.getUnencodedValue(input);

                    $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                    {
                        const promptInfo = this;

                        hiddenConditionInfos[promptInfo.promptUniqueID] = promptInfo.hiddenCondition;
                    });

                    return askServerToEvaluateHiddenConditions(hiddenConditionInfos, promptUniqueID, inputValue, dataType, order);
                }

                return null;
            }

            /**
             * Sends an AJAX request to evaluate the provides Hidden Conditions
             * @param {Array} hiddenConditionInfos An Array of Hidden Conditions
             * @param {string} promptUniqueID The Prompt Unique ID of the prompt that changed
             * @param {any} value The value of the Prompt Input that changed
             * @param {string} promptDataType The data type of the Prompt Input that changed
             * @param {number} order If multiple changes are being processed the order they should be processed in
             * @returns {Promise} A Promise object for the AJAX request to evaluate the Hidden Condition or null if the input has no prompts looking to it for changes
             */
            function askServerToEvaluateHiddenConditions(hiddenConditionInfos, promptUniqueID, value, promptDataType, order = 0)
            {
                return $.ajax(skyward.global.virtualDir + "Reporting/Report/EvaluateUserConditions",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            promptData: skyward.extensions.encodeHtml(JSON.stringify({
                                UserConditionInfos: hiddenConditionInfos,
                                UniqueID: promptUniqueID,
                                BoundValue: value,
                                DataType: promptDataType,
                                Order: order
                            }))
                        }
                    });
            }

            /**
             * Waits for all the AJAX Request Promises to be completed then processes the results in the order they were requested
             * @param {Array} resultPromises An Array of Promises to be completed
             * @param {boolean} checkChildHiddenConditionsOnShow True if when showing a prompt we should then check if its children should be shown
             */
            function handleHiddenConditionEvaluationPromises(resultPromises, checkChildHiddenConditionsOnShow)
            {
                Promise.all(resultPromises)
                    .then(function (resultsCollection)
                    {
                        for (const resultObject of resultsCollection.sort(function (a, b) { return a.order - b.order }))
                        {
                            for (const resultPromptUniqueID in resultObject.results)
                            {
                                const shouldHide = resultObject.results[resultPromptUniqueID];
                                togglePrompt(shouldHide, resultPromptUniqueID, checkChildHiddenConditionsOnShow)
                            }
                        }
                    });
            }

            /**
             * Toggles the prompt with the given prompt unique ID. If the prompt is hidden it will also clear the value and hide any prompts dependent on it.
             * @param {boolean} shouldHide True if the field set will be hidden
             * @param {string} promptUniqueID The prompt unique ID of the prompt to find
             * @param {boolean} checkChildHiddenConditionsOnShow True if when showing this prompt we should then check if its children should be shown
             */
            function togglePrompt(shouldHide, promptUniqueID, checkChildHiddenConditionsOnShow)
            {
                const fieldSet = fieldSetByPromptUniqueID.get(promptUniqueID);
                const isStandardFilter = fieldSet.hasClass("standardFilterViewer");
                fieldSet.toggleClass("doNotPost", shouldHide);

                fieldSet.toggle(!shouldHide);

                fieldSet.find(".filterValue").each((index, e) =>
                {
                    let filterValueElement = $(e);
                    filterValueElement.toggleClass("doNotPost", shouldHide);

                    if (!isStandardFilter)
                    {
                        if (shouldHide)
                        {
                            hidePromptsThatWatchThisPrompt(promptUniqueID);
                        }
                        else if (checkChildHiddenConditionsOnShow)
                        {
                            evaluateHiddenConditions(filterValueElement);
                        }
                    }

                    filterValueElement.trigger("togglePrompt");

                });
            }

            /**
             * Hides any prompt that is watching the Prompt of the provided Prompt Unique ID then recursively calls itself until there are no prompts to hide
             * @param {string} promptUniqueID The Prompt Unique ID of the Prompt that was hidden
             */
            function hidePromptsThatWatchThisPrompt(promptUniqueID)
            {
                if (conditionalPromptInfo.has(promptUniqueID))
                {
                    $(conditionalPromptInfo.get(promptUniqueID)).each(function ()
                    {
                        const promptInfo = this;
                        togglePrompt(true, promptInfo.promptUniqueID, false)
                    });
                }
            }
        };

        skyward.promptsview.setModifiedNotification = function ()
        {
            let collapsePanel = $(this).closest(".collapsePanel");
            let collapsePanelHeaderTextContainer = collapsePanel.find(".collapsePanelHeaderTextContainer").not(".js-ignoreModifiedFilter");

            let onlyInputsWithValueSet = function ()
            {
                let value = skyward.controls.getValue(this);
                return skyward.promptsview.isNonEmptyPromptValue(value);
            };

            if (collapsePanel.find(".filterViewValue, .filterValue, .filterProcessingListValue").filter(onlyInputsWithValueSet).length)
            {
                if (!collapsePanelHeaderTextContainer.find(".hasValues").length)
                {
                    collapsePanelHeaderTextContainer.append($("<span class='hasValues'>(modified)</span>"));
                }
            }
            else
            {
                collapsePanelHeaderTextContainer.find(".hasValues").remove();
            }
        };

        skyward.promptsview.isNonEmptyPromptValue = function (value)
        {
            let result = !(value == null || !value || value == "" || $.isEmptyObject(value)
                || (Array.isArray(value) && (value.length == 0 || (value.length == 1 && value[0] == ""))));

            if (result && value instanceof Date)
            {
                result = !isNaN(value);
            }

            return result;
        };

        skyward.window.registerLoadDOMCallback(initParametersPrompt);

    }(window.skyward = window.skyward || {}, window.jQuery)
);